import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc39ee16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link-dialog" }
const _hoisted_2 = {
  key: 2,
  class: "preview"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "预览：", -1))
const _hoisted_4 = { class: "btns" }

import { computed, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTElementLink } from '@/types/slides'
import useLink from '@/hooks/useLink'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import Tabs from '@/components/Tabs.vue'
import Input from '@/components/Input.vue'
import Button from '@/components/Button.vue'
import Select from '@/components/Select.vue'

type TypeKey = 'web' | 'slide'
interface TabItem {
  key: TypeKey
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkDialog',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { handleElement } = storeToRefs(useMainStore())
const { slides, currentSlide } = storeToRefs(useSlidesStore())

const type = ref<TypeKey>('web')
const address = ref('')
const slideId = ref('')

const slideOptions = computed(() => {
  return slides.value.map((item, index) => ({
    label: `幻灯片 ${index + 1}`,
    value: item.id,
    disabled: currentSlide.value.id === item.id,
  }))
})

slideId.value = slides.value.find(item => item.id !== currentSlide.value.id)?.id || ''

const selectedSlide = computed(() => {
  if (!slideId.value) return null

  return slides.value.find(item => item.id === slideId.value) || null
})

const tabs: TabItem[] = [
  { key: 'web', label: '网页链接' },
  { key: 'slide', label: '幻灯片页面' },
]

const { setLink } = useLink()

onMounted(() => {
  if (handleElement.value?.link) {
    if (handleElement.value.link.type === 'web') address.value = handleElement.value.link.target
    else if (handleElement.value.link.type === 'slide') slideId.value = handleElement.value.link.target

    type.value = handleElement.value.link.type
  }
})

const save = () => {
  const link: PPTElementLink = {
    type: type.value,
    target: type.value === 'web' ? address.value : slideId.value,
  }
  if (handleElement.value) {
    const success = setLink(handleElement.value, link)
    if (success) emit('close')
    else address.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tabs, {
      tabs: tabs,
      value: type.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((type).value = $event)),
      tabsStyle: { marginBottom: '20px' }
    }, null, 8, ["value"]),
    (type.value === 'web')
      ? (_openBlock(), _createBlock(Input, {
          key: 0,
          class: "input",
          value: address.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((address).value = $event)),
          placeholder: "请输入网页链接地址"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (type.value === 'slide')
      ? (_openBlock(), _createBlock(Select, {
          key: 1,
          class: "input",
          value: slideId.value,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((slideId).value = $event)),
          options: slideOptions.value
        }, null, 8, ["value", "options"]))
      : _createCommentVNode("", true),
    (type.value === 'slide' && selectedSlide.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(ThumbnailSlide, {
            class: "thumbnail",
            slide: selectedSlide.value,
            size: 500
          }, null, 8, ["slide"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})